module.exports = __webpack_public_path__ + "img/9e3c83f0yy397328565cd3d2674977d4.fb60766c.jpg";